import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../Firebase';
import { collection, getDocs } from 'firebase/firestore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { FiCalendar, FiUser, FiAward, FiMapPin } from 'react-icons/fi';

gsap.registerPlugin(ScrollTrigger);

const Doctors = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const snap = await getDocs(collection(db, 'doctors'));
        const doctorsList = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setDoctors(doctorsList);
      } catch (err) {
        console.error("Error fetching doctors:", err);
      }
    };
    fetchDoctors();
  }, []);

  useEffect(() => {
    if (doctors.length > 0) {
      const ctx = gsap.context(() => {
        gsap.fromTo(
          '.doctor-card',
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.15,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: '.doctors-grid',
              start: 'top 85%',
              toggleActions: 'play none none none'
            }
          }
        );
      }, sectionRef);
      return () => ctx.revert();
    }
  }, [doctors]);

  return (
    <section id="find-doctor" className="section section-alt" ref={sectionRef}>
      <div>
        <div className="section-header">
          <span className="section-tag">Medical Experts</span>
          <h2 className="section-title">Our Team of Specialists</h2>
          <p className="section-subtitle">
            Consult with some of the best medical specialists from around the country, dedicated to providing safety and quality care.
          </p>
        </div>

        <div className="doctors-grid">
          {doctors.map((doctor) => (
            <article key={doctor.id} className="doctor-card">
              <div className="doctor-img-container">
                {doctor.image ? (
                  <img
                    src={doctor.image.startsWith('http') ? doctor.image : (process.env.PUBLIC_URL + doctor.image)}
                    alt={doctor.name}
                    className="doctor-img"
                    loading="lazy"
                  />
                ) : (
                  <div className="doctor-img-placeholder">
                    <FiUser className="placeholder-icon" />
                  </div>
                )}
                {/* Overlay Badge */}
                <span className="doctor-badge">{doctor.specialty}</span>
              </div>
              
              <div className="doctor-info">
                <h3 className="doctor-name">{doctor.name}</h3>
                
                <div className="doctor-meta-details">
                  <div className="doctor-meta-item">
                    <FiAward className="meta-icon" />
                    <span>{doctor.experience}</span>
                  </div>
                  <div className="doctor-meta-item">
                    <FiMapPin className="meta-icon" />
                    <span>{doctor.location}</span>
                  </div>
                </div>
                
                <p className="doctor-focus-text">
                  "{doctor.focus || 'Dedicated to providing comprehensive medical guidance and compassionate care.'}"
                </p>
                
                <div className="doctor-actions">
                  <button
                    type="button"
                    className="btn btn-primary doctor-book-btn"
                    onClick={() =>
                      navigate('/appointments', {
                        state: {
                          doctorName: doctor.name,
                          specialty: doctor.specialty,
                        },
                      })
                    }
                  >
                    <FiCalendar /> Book Appointment
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-outline doctor-profile-btn"
                    onClick={() => navigate('/doctors')}
                  >
                    View Profile
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Doctors;
